export default __webpack_public_path__ + "static/media/7_1.a990ef97.jpg";